import React, { useEffect, useState } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { deleteMessengerConfig } from "V2.0/services/messengerService";
import { message } from "antd";
import CopyInput from "V2.0/common/CopyInput";
import { Button } from "V2.0/common/button";
import { Badge } from "V2.0/common/badge";

import MessengerIcon from "V2.0/images/messenger.svg";
import { showErrorToast } from "V2.0/utils";

function MessengerConnected({
  projectId,
  messengerConfiguration,
  fetchMessengerConfiguration,
  isViewOnly,
}) {
  const [loading, setLoading] = useState(false);

  const handleMessenger = async (data) => {
    message.loading("Disconnecting");
    try {
      const response = await deleteMessengerConfig(projectId);
      if (response.status === 200) {
        message.destroy();
        message.success("Messenger Disconnected");
        fetchMessengerConfiguration(projectId);
        setLoading(false);
      }
    } catch (ex) {
      setLoading(false);
      message.destroy();
      showErrorToast(ex, "Failed to disconnect Messenger");
    }
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <div className="w-full max-w-md p-8 border rounded-lg">
          <div className="flex gap-x-2 mb-4">
            <img
              src={MessengerIcon}
              width={24}
            />
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Messenger
            </h3>
            <Badge color="emerald">Connected</Badge>
          </div>
          <div className="flex flex-col gap-y-8">
            <div className="mt-5">
              <CopyInput
                value="https://api.apivoicecall.com/api/messenger/webhook"
                title="Messenger Webhook URL"
              />
            </div>

            <div className="">
              <CopyInput
                value="4915359cede4b64cb190f02bc1b396af"
                title="Verify token"
              />
            </div>
            <div>
              <CopyInput
                value={messengerConfiguration?.messengerToken}
                title="Messenger Token"
              />
            </div>
            <div>
              <CopyInput
                value={messengerConfiguration?.pageID}
                title="Page ID"
              />
            </div>
            {!isViewOnly && (
              <Button
                loading={loading}
                onClick={handleMessenger}
              >
                Disconnect Messenger
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessengerConnected;
